<template>
  <svg
    :height="height"
    :width="width"
    id="add_media"
    style="enable-background:new 0 0 100 100;"
    version="1.1"
    viewBox="0 0 100 100"
    x="0px" y="0px"
    xml:space="preserve"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    >
    <polygon class="st0" opacity="0.1" :fill="$vuetify.theme.primary" points="19.3,3.2 15.9,20 79.3,22.3 84.3,33.2 84.3,61.5 88.4,62.1 91.5,63.8 97.7,19.4 93.5,10.8 "/>
    <circle class="st0" opacity="0.1" :fill="$vuetify.theme.primary" cx="50.2" cy="41.5" r="6.3"/>
    <path class="st1" :fill="iconColor" d="M50.6,51.4c5.6,0,10.2-4.6,10.2-10.2S56.2,31,50.6,31s-10.2,4.6-10.2,10.2S45,51.4,50.6,51.4L50.6,51.4z
       M50.6,35.8c3,0,5.3,2.4,5.3,5.3c0,3-2.4,5.3-5.3,5.3c-3,0-5.3-2.4-5.3-5.3S47.7,35.8,50.6,35.8L50.6,35.8z"/>
    <path class="st1" :fill="iconColor" d="M61.3,82.8H9.4C7,82.9,5,81,4.9,78.6c0-0.1,0-0.2,0-0.4v-9l18.8-13.8c2.3-1.7,5.4-1.6,7.5,0.4l13.2,11.7
    c2,1.7,4.5,2.6,7.2,2.7c2.1,0,4.1-0.5,5.8-1.6l23.9-13.8v6.6c0.2,0,0.4,0,0.6,0c1.5,0,2.9,0.2,4.3,0.5V28.5C86,23,81.5,18.5,76,18.4
    H18l1.1-9.5c0.2-1.2,0.9-2.3,1.8-3.2c1.1-0.7,2.4-1.1,3.6-1l66.2,7.7c2.7,0.4,4.6,2.7,4.4,5.4L89.9,63c1.7,0.7,3.2,1.7,4.7,2.8
    l5.4-47.2c0.6-5.4-3.2-10.2-8.6-10.9L25,0.1c-2.6-0.4-5.2,0.4-7.2,2.1c-2,1.5-3.3,3.8-3.5,6.3l-1.2,10H9.4C4,18.4,0,23.2,0,28.5
    v49.7c-0.1,5.1,3.9,9.3,9,9.5c0.1,0,0.2,0,0.4,0h52.7C61.7,86.1,61.4,84.5,61.3,82.8z M4.9,28.5c0-2.6,1.8-5.2,4.5-5.2H76
    c2.9,0.1,5.2,2.4,5.3,5.2v20.4L54.9,64.4c-2.3,1.3-5.2,1.1-7.2-0.6L34.4,52c-3.8-3.3-9.4-3.5-13.5-0.5l-16,11.7V28.5z"/>
    <g>
      <circle class="st2" opacity="0.5" :fill="$vuetify.theme.primary" cx="81.9" cy="81.9" r="13.9"/>
      <g>
        <path class="st1" :fill="iconColor" d="M91.2,80.3h-8.4v-8.4c0-0.5-0.4-0.9-0.9-0.9h-1.2c-0.5,0-0.9,0.4-0.9,0.9v8.4h-8.4c-0.5,0-0.9,0.4-0.9,0.9
          v1.2c0,0.5,0.4,0.9,0.9,0.9h8.4v8.4c0,0.5,0.4,0.9,0.9,0.9h1.2c0.5,0,0.9-0.4,0.9-0.9v-8.4h8.4c0.5,0,0.9-0.4,0.9-0.9v-1.2
          C92,80.7,91.7,80.3,91.2,80.3z"/>
        <path class="st3" fill="#F5F5F5" d="M81.9,71c0.5,0,0.9,0.4,0.9,0.9v8.4h8.4c0.5,0,0.9,0.4,0.9,0.9v1.2c0,0.5-0.4,0.9-0.9,0.9h-8.4v8.4
          c0,0.5-0.4,0.9-0.9,0.9h-1.2c-0.5,0-0.9-0.4-0.9-0.9v-8.4h-8.4c-0.5,0-0.9-0.4-0.9-0.9v-1.2c0-0.5,0.4-0.9,0.9-0.9h8.4v-8.4
          c0-0.5,0.4-0.9,0.9-0.9H81.9 M81.9,70h-1.2c-1,0-1.9,0.8-1.9,1.9v7.3h-7.3c-1,0-1.9,0.8-1.9,1.9v1.2c0,1,0.8,1.9,1.9,1.9h7.3v7.3
          c0,1,0.8,1.9,1.9,1.9h1.2c1,0,1.9-0.8,1.9-1.9v-7.3h7.3c1,0,1.9-0.8,1.9-1.9v-1.2c0-1-0.8-1.9-1.9-1.9h-7.3v-7.3
          C83.8,70.9,83,70,81.9,70L81.9,70z"/>
      </g>
      <path class="st1" :fill="iconColor" d="M81.9,100c-10,0-18.1-8.1-18.1-18.1S72,63.8,81.9,63.8c10,0,18.1,8.1,18.1,18.1S91.9,100,81.9,100z M81.9,66.8
        c-8.3,0-15.1,6.8-15.1,15.1S73.6,97,81.9,97S97,90.2,97,81.9S90.2,66.8,81.9,66.8z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
